import React from 'react';
import { Link } from 'react-router-dom';

const Sobre: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 text-white py-16">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Sobre a BOILX</h1>
          <p className="text-xl text-green-100 max-w-2xl">
            Conectando criadores, compradores e o melhor do agronegócio brasileiro.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto">
          {/* Mission */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Nossa Missão</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              A BOILX nasceu com o objetivo de revolucionar o mercado de compra e venda de animais 
              no Brasil. Somos o marketplace que conecta criadores, haras, fazendas e compradores 
              de todo o país em uma plataforma segura, moderna e fácil de usar.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Acreditamos que a tecnologia pode transformar o agronegócio, tornando as negociações 
              mais transparentes, eficientes e acessíveis para todos.
            </p>
          </section>

          {/* Values */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Nossos Valores</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="text-3xl mb-3">🤝</div>
                <h3 className="font-semibold text-gray-900 mb-2">Confiança</h3>
                <p className="text-gray-600 text-sm">
                  Construímos relações baseadas na transparência e honestidade.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="text-3xl mb-3">🚀</div>
                <h3 className="font-semibold text-gray-900 mb-2">Inovação</h3>
                <p className="text-gray-600 text-sm">
                  Buscamos constantemente melhorar a experiência dos nossos usuários.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="text-3xl mb-3">🌱</div>
                <h3 className="font-semibold text-gray-900 mb-2">Sustentabilidade</h3>
                <p className="text-gray-600 text-sm">
                  Apoiamos práticas responsáveis no agronegócio brasileiro.
                </p>
              </div>
            </div>
          </section>

          {/* Stats */}
          <section className="bg-green-700 text-white rounded-2xl p-8 mb-12">
            <h2 className="text-2xl font-bold mb-6 text-center">BOILX em Números</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              <div>
                <div className="text-3xl font-bold">5.000+</div>
                <div className="text-green-200 text-sm">Usuários Cadastrados</div>
              </div>
              <div>
                <div className="text-3xl font-bold">10.000+</div>
                <div className="text-green-200 text-sm">Anúncios Publicados</div>
              </div>
              <div>
                <div className="text-3xl font-bold">27</div>
                <div className="text-green-200 text-sm">Estados Atendidos</div>
              </div>
              <div>
                <div className="text-3xl font-bold">98%</div>
                <div className="text-green-200 text-sm">Satisfação</div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Faça Parte da BOILX</h2>
            <p className="text-gray-600 mb-6">
              Junte-se a milhares de criadores e compradores que já confiam na nossa plataforma.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/registrar"
                className="px-8 py-3 bg-green-700 text-white rounded-lg font-semibold hover:bg-green-800 transition-colors"
              >
                Criar Conta Grátis
              </Link>
              <Link
                to="/anuncios"
                className="px-8 py-3 border-2 border-green-700 text-green-700 rounded-lg font-semibold hover:bg-green-50 transition-colors"
              >
                Ver Anúncios
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Sobre;
